module.exports = __webpack_public_path__ + "img/H8.a0de42fb.jpg";